import React, { memo, useCallback } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Stack, Body1 } from '@collaborate-health/uikit'
import routes from '@tabeeb/routes'
import { useDispatch } from '@tabeeb/store'
import { push } from 'connected-react-router'
import { UserSettingsTabs } from '@tabeeb/modules/account/helper'
import { sessionTitleFormatter } from '@tabeeb/shared/utils/text'
import RequiredQualificationsList from '@tabeeb/modules/sessionsPage/components/Dialogs/RequiredQualificationsDialog/RequiredQualificationsList'

interface RequiredQualificationsDialogProps {
  open: boolean
  onClose: () => void
  session: {
    MissingQualifications: number[]
    QualificationsRequired: number[]
  }
}

const RequiredQualificationsDialog: React.FC<RequiredQualificationsDialogProps> = ({ open, onClose, session }) => {
  const dispatch = useDispatch()

  const onGoToUpdateQualifications = useCallback(() => {
    const link = `${routes.userSettings}?tab=${UserSettingsTabs.Certificates}`
    dispatch(push(link))
    onClose()
  }, [onClose, dispatch])

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { minWidth: 500 } }}>
      <DialogTitle>Required qualifications</DialogTitle>
      <DialogContent>
        <Stack>
          <Body1>
            {sessionTitleFormatter.format("To access this session, you'll need the following qualifications:")}
          </Body1>
          <RequiredQualificationsList
            missingQualificationIds={session.MissingQualifications}
            qualificationIds={session.QualificationsRequired}
          />
          <Body1>Please, make sure your profile is up to date</Body1>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='text' color='primary' onClick={onGoToUpdateQualifications}>
          Update qualifications
        </Button>
        <Button variant='contained' color='primary' onClick={onClose}>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default memo(RequiredQualificationsDialog)

